import React from "react";
import AddCircle from "@material-ui/icons/AddCircle";
import moduleStyle from "./CustomFooter.module.css";
import { FooterItemList } from "./modules/FooterItemList";
import { SECTION_SIDE_KEYS } from "./CustomFooter.constants";
import { useCustomFooter } from "./utils/useCustomFooter";
import { AddLineModal } from "./modules/AddLineModal";
import { Button } from "@my-scoot/component-library-legacy";
import { InfoOutlined } from "@material-ui/icons";
import { Switch } from "@my-scoot/component-library-legacy";

export const CustomFooterContext = React.createContext();

export const CustomFooter = ({ disableAllEdits }) => {
  const provider = useCustomFooter();
  const { set_show_modal, processing, handleSave, show_modal, set_data, data } =
    provider;

  return (
    <CustomFooterContext.Provider value={provider}>
      <div className={`mt-2 ${moduleStyle.info}`}>
        <InfoOutlined className={`${moduleStyle.infoIcon}`} />
        Note: The custom footer will replace your existing footer.
      </div>
      <FooterItemList section_side={SECTION_SIDE_KEYS.left_section} />
      <FooterItemList section_side={SECTION_SIDE_KEYS.right_section} />

      <div className={`mt-3 d-flex align-items-center`}>
        <Switch
          checked={data?.hide_footer === true}
          onChange={(_, checked) => {
            set_data({ ...data, hide_footer: checked });
          }}
        />
        <div className="ml-2">Hide footer from webpage</div>
      </div>

      <div className={`d-flex mt-4 align-items-center justify-content-between`}>
        {disableAllEdits ? (
          <div />
        ) : (
          <div
            onClick={() => set_show_modal(true)}
            className={`${moduleStyle.action_color} ${moduleStyle.text_cta} pointer`}
          >
            <AddCircle />
            <span className={`ml-2`}>Add new line</span>
          </div>
        )}

        <Button
          variant="contained"
          color="primary"
          disableElevation
          disabled={processing || disableAllEdits}
          loading={processing}
          onClick={handleSave}
        >
          Save
        </Button>
      </div>

      {show_modal && <AddLineModal />}
    </CustomFooterContext.Provider>
  );
};
